import { compose } from 'recompose'
import PopoverContent from './PopoverContent'

export default compose()(PopoverContent)

